import * as ANIMATION_DEFINITIONS from "./definitions";
import { initializeRegistryWithDefinitions } from "./registry";
initializeRegistryWithDefinitions(ANIMATION_DEFINITIONS); // export { createUseAnimation } from './createUseAnimation'

export { EASING_FUNCTIONS as EASING } from "./easing";
export { getAnimationConfigByName as getAnimationByName, initializeRegistryWithDefinitions, registerAnimation } from "./registry";